import { eventTimeZoneLabel, localInputToIso } from '../../utils/eventDateTime';

const INPUT_CLASS =
    'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500';
const ERROR_INPUT_CLASS = 'border-red-300 focus:ring-red-500 focus:border-red-500';
const FIELD_LABEL_CLASS = 'block text-[13px] font-semibold text-gray-700 mb-1.5';

interface EventDateTimeFieldProps {
    label: string;
    value: string;
    onChange: (localValue: string) => void;
    error?: string;
    required?: boolean;
}

/** A `datetime-local` input read/written in the AUTHOR's own browser zone (see
 *  utils/eventDateTime.ts) - the label states whose clock the number is in. */
export function EventDateTimeField({
    label,
    value,
    onChange,
    error,
    required
}: EventDateTimeFieldProps) {
    const iso = localInputToIso(value);
    return (
        <div>
            <label className={FIELD_LABEL_CLASS}>
                {label} {required && '*'}
                <span className="ml-1 font-normal text-gray-400">({eventTimeZoneLabel(iso)})</span>
            </label>
            <input
                type="datetime-local"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className={`${INPUT_CLASS} ${error ? ERROR_INPUT_CLASS : ''}`}
            />
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
    );
}
